import { type ReactElement } from 'react';
import dayjs, { type Dayjs } from 'dayjs';
import { type CalendarDay } from '../Calendar';

interface Props {
  height: number;
  days: CalendarDay[];
}

const hasBackground = (day: Dayjs): boolean => {
  const dayOfWeek = day.day();
  return [0, 2, 4, 6].includes(dayOfWeek);
};

export const GridLayer = (props: Props): ReactElement => {
  const { height, days } = props;

  const Day = (row: number) => (
    <div className="flex flex-row w-full">
      {Array.from({ length: 23 }).map((_, index) => (
        <div
          key={`grid-tile-${row}-${index}`}
          className="flex w-full"
          style={{ height, boxShadow: 'inset -1px 0px 0px 0px #ccc' }}
        />
      ))}
      <div key={`grid-tile-${row}-24`} className="flex w-full" />
    </div>
  );

  return (
    <div className="flex flex-col w-full">
      {days.map((day, index) => (
        <div
          className={hasBackground(dayjs(day.date)) ? 'bg-slate-50' : ''}
          key={`grid-row-${index}`}
        >
          {Day(index)}
        </div>
      ))}
    </div>
  );
};
